
import React from 'react'
import './Imagemid.css'

const Imagemid = () => {
  return (
    <div className='pl'>
   <div className="photo">
   <div className="tt1"><span>define your paradise</span></div>
    <div className="tt2">SHOP OUTERDOOR PLANTERS</div>
    <img src="https://cb.scene7.com/is/image/Crate/CB_20230720_HP_Outdoor1?wid=1440&qlt=80&op_sharpen=1" alt="" />
    {/* <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_FallDecor1?wid=1440&qlt=80&op_sharpen=1" alt=""/> */}
   </div>

   <div className="photo2">
   <div className="tt1"><span>define your paradise</span></div>
    <div className="tt2">SHOP OUTERDOOR PLANTERS</div>
   <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_Bedding2Left1?wid=720&qlt=80&op_sharpen=1" alt="" />
   <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_WineRight1?wid=720&qlt=80&op_sharpen=1" alt="" />
   </div>

   

   <div className="photo">
   <div className="tt1"><span>define your paradise</span></div>
    <div className="tt2">SHOP OUTERDOOR PLANTERS</div>
   <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_Tour1?wid=1440&qlt=80&op_sharpen=1" alt="" />
   </div>

   

   <div className="photo3">
   <div className="tt3"><span>define your paradise</span></div>
    <div className="tt4">SHOP OUTERDOOR PLANTERS</div>
   <img src="https://cb.scene7.com/is/image/Crate/CB_DHP_20230713_BakingDiptych2?wid=1440&qlt=80&op_sharpen=1" alt="" />
   {/* <div className="tt5"><span>define your paradise</span></div>
    <div className="tt6">SHOP OUTERDOOR PLANTERS</div> */}
   <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_Outdoor1?wid=1440&qlt=80&op_sharpen=1" alt="" />
   </div>
   </div>
  )
}

export default Imagemid